/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Collapse } from '@atoms';
import { usePagination } from '@hooks';

import PostForm from './PostForm';
import PostsList from './PostsList';

const ItemFooter = ({ parentId, parentType, content }) => {
  const pagination = usePagination({ initialPerPage: 9, useSearchParam: () => React.useState() });

  return (
    <div style={{ padding: 20 }}>
      <Collapse style={{ marginBottom: 40 }}>
        <Collapse.Panel header="New post">
          <PostForm
            {...{
              parentId,
              parentType,
              liveBlogId: content?.id || null,
            }}
            onSuccess={pagination.reset}
          />
        </Collapse.Panel>
      </Collapse>
      <PostsList
        {...{
          parentId,
          parentType,
          pagination,
          liveBlogId: content?.id || null,
        }}
      />
    </div>
  );
};

export default ItemFooter;
